import React from 'react'


const ReplayIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 17V6L5 11.5L11 17ZM19 17V6L13 11.5L19 17Z" stroke="currentColor" strokeWidth="0.9"/>
        </svg>
    )
}

export default ReplayIcon